/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function Pinterest({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<path d="M1 8C1 10.9884 2.87308 13.5399 5.50917 14.5438C5.445 13.9972 5.37675 13.096 5.52375 12.4637C5.65033 11.92 6.341 8.99983 6.341 8.99983C6.341 8.99983 6.13275 8.58275 6.13275 7.965C6.13275 6.99667 6.69392 6.27333 7.39333 6.27333C7.98833 6.27333 8.27533 6.71958 8.27533 7.2545C8.27533 7.85242 7.89442 8.74608 7.69783 9.575C7.53392 10.2686 8.04608 10.8344 8.72975 10.8344C9.96817 10.8344 10.9207 9.52833 10.9207 7.643C10.9207 5.97408 9.72142 4.808 8.00933 4.808C6.02717 4.808 4.86342 6.29492 4.86342 7.832C4.86342 8.43108 5.09383 9.07275 5.382 9.42217C5.40657 9.44856 5.42393 9.48083 5.43241 9.51587C5.44089 9.55091 5.4402 9.58755 5.43042 9.62225C5.37733 9.84275 5.2595 10.3158 5.23675 10.4127C5.20583 10.5398 5.13583 10.5672 5.00342 10.5054C4.13308 10.1006 3.58942 8.82833 3.58942 7.80633C3.58942 5.60775 5.186 3.58942 8.19308 3.58942C10.6104 3.58942 12.4893 5.312 12.4893 7.61383C12.4893 10.0154 10.9756 11.9486 8.87325 11.9486C8.16683 11.9486 7.50358 11.5811 7.27608 11.1477C7.27608 11.1477 6.92667 12.4788 6.84208 12.8043C6.67758 13.4367 6.22142 14.237 5.9385 14.6914C6.59067 14.8921 7.2825 15 8 15C11.8657 15 15 11.8657 15 8C15 4.13425 11.8657 1 8 1C4.13425 1 1 4.13425 1 8Z" fill="#E60023"></path>

    </svg>
  );
}
